/**
 * PATH: packages/email-hub/src/feature/components/inboxScopeCounts.ts
 * FILE_ID: EMAIL-INBOX-SCOPE-COUNTS-001
 * PURPOSE: Derive Focus/Everything/Done/Junk folder totals from EmailStats.
 * WHY: B-03 honest counts — stats.by_folder already fetched; tabs need badges.
 * FLOW: by_folder keys → Partial<Record<InboxScope, number>>
 */
import type { EmailStats } from '../hooks/useEmails.types'
import type { InboxScope } from './InboxScopeBar'

/** Keys observed in FE optimistic deltas + BE list stats. */
export function deriveInboxScopeCounts(
  stats: EmailStats | null | undefined,
): Partial<Record<InboxScope, number>> {
  if (!stats) return {}
  const folders = stats.by_folder || {}
  const inbox = num(folders.inbox)
  const archive = num(folders.archive)
  const junk = num(folders.binned ?? folders.trash ?? folders.junk)
  const out: Partial<Record<InboxScope, number>> = {}
  if (inbox !== undefined) out.focus = inbox
  if (inbox !== undefined || archive !== undefined) {
    out.all = (inbox ?? 0) + (archive ?? 0)
  }
  if (archive !== undefined) out.done = archive
  if (junk !== undefined) out.junk = junk
  return out
}

function num(value: unknown): number | undefined {
  if (typeof value !== 'number' || !Number.isFinite(value)) return undefined
  return Math.max(0, Math.floor(value))
}
